// Module
var code = "<p><strong>Placard ID: </strong><button class=\"ups-link\" type=\"button\" (click)=\"showDetail(dataSearch?.placardId)\">{{ dataSearch?.placardId }}</button></p>\r\n<p><strong>Status: </strong><span>Canceled on {{dataSearch.cancelDate}}</span></p>\r\n";
// Exports
module.exports = code;